<div class="custom-container">
    <img
        class="logo mt-5 mx-auto d-block"
        ngSrc="assets/images/sprintpay-horizontal-logo.svg"
        alt="Cargo Sprint Logo"
        width="270"
        height="60"
    />
    <div class="mb-3 header text-center">Vendor Application</div>
    <div class="header-description mb-5">
        Please provide the following information to join our SprintPay payment network
    </div>

    <mat-stepper linear labelPosition="end" #stepper>
        <mat-step [editable]="true" errorMessage="Personal information is needed" [completed]="isStepCompleted">
            <ng-template matStepLabel>Personal Information</ng-template>
            <ng-template matStepContent>
                <app-personal-information
                    #personaInformtionComponent
                    [formGroup]="personalInformationForm"
                    [stepper]="stepper"
                    (dynamicResponseEvent)="handleDynamicResponseEvent($event)"
                    (cancelEvent)="cancelEvent()"
                />
            </ng-template>
        </mat-step>

        <mat-step
            [editable]="true"
            errorMessage="Business Details information is needed"
            [stepControl]="businessDetailsForm"
        >
            <ng-template matStepLabel>Business Information</ng-template>
            <ng-template matStepContent>
                <app-business-details #businessDetails [formGroup]="businessDetailsForm" />
            </ng-template>
        </mat-step>

        <mat-step [editable]="true" errorMessage="Security information is needed" [stepControl]="securityForm">
            <ng-template matStepLabel>Security</ng-template>
            <ng-template matStepContent>
                <app-security-step
                    #securityStep
                    [formGroup]="securityForm"
                    [email]="personalInformationForm.controls['email'].value"
                    [dynamicResponse]="dynamicResponse"
                    (submitEvent)="submitEvent()"
                />
            </ng-template>
        </mat-step>
    </mat-stepper>
    <div class="existing__account text-center mb-5">
        Do you already have an account?
        <a class="signin-link" [routerLink]="['/login']">Sign in</a>
    </div>
</div>

<ng-template #twoFactorModal>
    <app-two-factor [module]="module" />
</ng-template>
